export default __webpack_public_path__ + "media/images/user_photos/164-98a6aa7941cc97ab186c393a64597db2.jpg";